module.exports = {
    "breadcrumbs": `Migas de pan`
};


//# sourceMappingURL=es-ES.main.js.map
